import { useLocale } from "../providers/LocaleProvider";

export interface LoadingIndicatorProps {
  /** The name of the file currently being processed */
  fileName: string;
}

/**
 * Animated loading indicator shown while a file is being processed.
 * Displays a pulsing spinner and the file name.
 *
 * The minimum display time logic (500ms if processing < 300ms) is handled
 * by the parent component that controls the processing state transition.
 */
export function LoadingIndicator({ fileName }: LoadingIndicatorProps) {
  const { t } = useLocale();

  return (
    <div className="loading-indicator" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true" />
      <p className="loading-label">
        {t("dropzone.processing")}
      </p>
      <p className="loading-filename">{fileName}</p>
    </div>
  );
}
